var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import React from 'react';
import classNames from 'classnames';
import { TreeExpandFunc, TreeCollapseFunc } from '@feb-team/legao-icons-react';
import { SpanTag } from '../../Utils/AtomicTag';
var Collapse = function (props) {
    var _a;
    var expanded = props.expanded, disabled = props.disabled;
    var icoClsString = classNames((_a = {},
        _a['text-gray-200 cursor-not-allowed'] = disabled,
        _a['cursor-pointer text-gray-600'] = !disabled,
        _a));
    var setIcoCls = icoClsString.split(/\s/g);
    return (React.createElement(SpanTag, { atomics: __spread(['w-px-10', 'h-px-10', 'transform'], setIcoCls), autoPrefixedClassName: "tree-collapse", style: { fontSize: '8px' } }, !expanded ? (React.createElement(TreeExpandFunc, { style: { verticalAlign: 'top' } })) : (React.createElement(TreeCollapseFunc, { style: { verticalAlign: 'top' } }))));
};
export default Collapse;
